<div
    class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent relative">

    @if (fireworksVisible()) {
    <div class="congrats-fireworks-overlay" aria-hidden="true">
        <div class="pyro">
            <div class="before"></div>
            <div class="after"></div>
        </div>
    </div>
    }

    <div
        class="my-6 p-4 mx-auto h-16 w-16 rounded-full bg-linear-to-br from-primary to-brand-agency-dark text-white flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-10">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    </div>

    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        You're ready to go
        <span class="bg-linear-to-r from-brand-agency to-brand-studio bg-clip-text text-transparent">viral!</span> 🚀
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">Your
        agency has been created and your brands have been added.</p>



    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">





        <!-- What happens Next -->
        <div class="mt-8 sm:mt-12">
            <h3 class="text-md sm:text-lg font-semibold text-primary mb-2 sm:mb-4">What happens next:</h3>

            <div class="flex flex-col gap-y-6 sm:gap-y-8">
                <!-- Step 1: Creators review your brief -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Start briefing creators</h4>
                        <p class="text-xs sm:text-sm text-secondary">Select one of your brands and start building
                            briefs.</p>
                    </div>
                </div>

                <!-- Step 2: Interested creators apply -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                            <polyline points="10 9 9 9 8 9" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Interested creators apply</h4>
                        <p class="text-xs sm:text-sm text-secondary">Creators who fit your vision submit their
                            applications</p>
                    </div>
                </div>

                <!-- Step 3: You approve your favorites -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                            <path d="M9 12l2 2 4-4" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">You approve your favorites</h4>
                        <p class="text-xs sm:text-sm text-secondary">Review applications and select the creators you
                            want to work with</p>
                    </div>
                </div>

                <!-- Step 4: Content gets created -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path d="M12 2L2 7l10 5 10-5-10-5z" />
                            <path d="M2 17l10 5 10-5" />
                            <path d="M2 12l10 5 10-5" />
                            <circle cx="12" cy="12" r="1" fill="white" />
                            <circle cx="7" cy="7" r="0.5" fill="white" />
                            <circle cx="17" cy="7" r="0.5" fill="white" />
                            <circle cx="7" cy="17" r="0.5" fill="white" />
                            <circle cx="17" cy="17" r="0.5" fill="white" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Content gets created</h4>
                        <p class="text-xs sm:text-sm text-secondary">Creators produce authentic UGC based on your
                            brief</p>
                    </div>
                </div>

                <!-- Step 5: Track performance in real-time -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <line x1="12" y1="20" x2="12" y2="10" />
                            <line x1="18" y1="20" x2="18" y2="4" />
                            <line x1="6" y1="20" x2="6" y2="16" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Track performance in real-time
                        </h4>
                        <p class="text-xs sm:text-sm text-secondary">Monitor views, engagement, and conversions from
                            your dashboard</p>
                    </div>
                </div>
            </div>
            <!-- What happens Next - END -->


        </div>



        <div class="w-full flex flex-col gap-y-2 mt-4">

            <div class="w-full flex flex-row items-center justify-center boder-b border-white/10">

                <button type="button" (click)="continueToDashboard()"
                    class="flex-1 sm:w-auto sm:min-w-40 text-center flashy-go-button text-primary flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold min-h-11 touch-manipulation order-1 sm:order-2">

                    <p class="block">Go to Dashboard</p>

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 shrink-0">
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>

                </button>

            </div>
        </div>


    </div>
</div>